export default class TwitterQuery {

    public static GetTwitter = `query GetTwitterQuery($input: TwitterInput!) {
            getTwitter(input: $input) {
                id
                date
                text
                retweetCount
                favoriteCount
            }     
        }`;
}